"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetCatalogues = void 0;
var _environment = require("@ori/environment");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
// istanbul ignore file @preserve -- api

const useGetCatalogues = () => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    data,
    error
  } = (0, _staticApiClientReact.useGetTenantCatalogues)(tenant, undefined, {
    swr: {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  });
  return (0, _react.useMemo)(() => ({
    catalogues: data?.collection ?? [],
    loading: data === undefined && error === undefined
  }), [data, error]);
};
exports.useGetCatalogues = useGetCatalogues;
